import { State } from './file-upload.reducer';
import { createSelector } from '@ngrx/store';

export const getFileUploadState = (state: { fileUpload: State }) => state.fileUpload;

const fileError = (fileId: string) => (state: State) => state[fileId].error;
const fileProgress = (fileId: string) => (state: State) => state[fileId].progress;
const fileSuccess = (fileId: string) => (state: State) =>
  state[fileId].progress === 100 && state[fileId].success;
const fileResponse = (fileId: string) => (state: State) => state[fileId].response;
const fileRequest = (fileId: string) => (state: State) => state[fileId].request;

export const filesUploading = (state: State) => {
  for (const fileId in state) {
    const fileUpload = state[fileId];
    if (fileUpload && !fileUpload.success && !fileUpload.error) {
      return true;
    }
  }
  return false;
};

export const getFileUploadError = (id: string) => createSelector(getFileUploadState, fileError(id));
export const getFileUploadProgress = (id: string) =>
  createSelector(getFileUploadState, fileProgress(id));
export const getFileUploadSuccess = (id: string) =>
  createSelector(getFileUploadState, fileSuccess(id));
export const getFileUploadResponse = (id: string) =>
  createSelector(getFileUploadState, fileResponse(id));

export const getFilesUploading = createSelector(getFileUploadState, filesUploading);
